import { useGetPartnerQuery } from '@/api/api.slice.tsx';
import { useGetPaymentMethod } from '@/features/OnBoarding/StepPayment/useGetPaymentMethod.tsx';
import { Field } from '@/features/OnBoarding/StepReview/Field.tsx';
import { Alert, Card, Loader, Typography } from '@arsnovasystems/ars-front-lib';
import CreditCardRoundedIcon from '@mui/icons-material/CreditCardRounded';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 *
 * Payment component.
 *
 * @returns JSX of the component
 */
export const PaymentSide = () => {
  const { t } = useTranslation();
  const { data: me, isLoading } = useGetPartnerQuery();
  const { meanOfPayment } = useGetPaymentMethod();

  if (isLoading || !me) {
    return <Loader />;
  }

  return (
    <Card
      title={t('ik.payment.informations')}
      subtitle={t('ik.onboarding.lastStep.subHeaderPaymentHint')}
      Avatar={<CreditCardRoundedIcon />}
      sx={{
        flex: 1,
      }}
    >
      <Stack sx={{ marginTop: 2, gap: '2px' }}>
        <Alert
          sx={{
            alignItems: 'center',
            marginBottom: 2,
          }}
          severity={'info'}
          compact={true}
        >
          <Typography variant={'body2'}>
            {t('ik.your.payment.method.has.been.saved ({{ paymentMode }})', {
              paymentMode: t('payment.' + (meanOfPayment?.type ?? '')),
            })}
          </Typography>
        </Alert>

        <Field
          label={t('ik.country.code')}
          value={me.country?.countryName ?? ''}
        />
        <Field
          label={t('ik.vat')}
          value={me.companyVatNumber}
        />
        <Field
          label={t('ik.accounting.email')}
          value={me.accountingEmail}
        />
        <Field
          label={t('ik.currency')}
          value={me.currency}
        />
      </Stack>
    </Card>
  );
};
